var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 320,
    viewBox: "0 0 480 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.3878 123.551H55.3848L56.3207 126.002L60.4731 136.892L83.1698 196.451H157.938L98.0261 136.279C90.0447 128.294 79.2105 123.551 67.9235 123.551H55.3884H55.3878Z",
    fill: "url(#paint0_linear_730_18201)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4719 136.891C68.6577 150.871 90.14 152.346 92.476 174.084C92.5726 174.975 93.256 175.692 94.1473 175.833C106.527 177.768 118.582 182.864 129.06 191.262L129.066 191.268C129.131 191.322 129.214 191.351 129.3 191.349C129.396 191.349 129.488 191.314 129.56 191.249C129.63 191.181 129.672 191.087 129.674 190.988C129.676 190.889 129.639 190.794 129.571 190.722C122.318 183.097 113.452 177.002 103.502 172.998L100.475 171.78C98.9153 171.152 97.8347 169.607 97.8828 167.828C98.0498 161.336 113.412 162.654 114.968 159.535L115.235 158.996C112.026 156.249 108.251 154.244 104.178 153.124C104.141 153.28 104.041 154.038 104.88 155.408C105.798 156.901 103.881 159.271 101.088 156.712L100.854 156.5C80.1001 137.484 64.5416 147.345 56.3184 126L60.4707 136.89L60.4719 136.891Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103.441 157.847V163.028C105.681 162.382 108.229 161.981 110.375 161.531V158.645C110.375 158.645 106.973 158.813 104.886 155.41C105.506 156.424 104.819 157.843 103.441 157.847Z",
    fill: "url(#paint1_linear_730_18201)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7152 176.281C108.188 178.487 119.308 183.442 129.057 191.26C113.458 177.93 103.95 175.898 99.5711 175.898C97.8478 175.898 96.9154 176.214 96.7148 176.281",
    fill: "url(#paint2_linear_730_18201)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3206 126L60.4726 136.89C68.6549 150.87 90.1372 152.344 92.477 174.075C90.111 146.338 77.9288 150.483 64.8404 137.863C61.4644 135.46 58.6082 131.939 56.3203 126H56.3206Z",
    fill: "url(#paint3_linear_730_18201)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M165.954 175.211C174.025 175.211 180.818 171.219 180.818 165.74C180.818 160.262 174.025 156.269 165.954 156.269C157.884 156.269 151.091 160.262 151.091 165.74C151.091 171.219 157.884 175.211 165.954 175.211ZM165.531 183.066C150.749 183.066 141.363 175.382 141.363 165.74C141.363 155.931 151.302 148.414 165.954 148.414C180.606 148.414 190.545 155.972 190.545 165.358C190.545 169.562 188.677 173.005 185.108 175.891H193.814L191.734 179.46C190.415 181.711 188.803 183.066 185.32 183.066H165.531ZM210.797 170.2H226.17L219.035 157.501C218.868 157.204 218.738 157.119 218.485 157.119C218.229 157.119 218.103 157.204 217.932 157.501L210.797 170.2ZM230.122 177.208H206.849L203.536 183.069H193.895L210.032 155.124C211.306 152.914 213.134 151.217 216.784 151.217H220.395C224.049 151.217 225.873 152.914 227.147 155.124L243.285 183.069H233.435L230.122 177.208ZM289.234 151.216V183.068H280.614L255.302 161.961V183.068H246.678V151.216H252.074C254.834 151.216 256.234 151.937 257.805 153.296L280.614 172.283V151.216H289.234ZM319.893 158.394V183.07H311.273V158.394H293.605V151.218H337.561V158.394H319.893ZM346.943 170.2H362.316L355.181 157.501C355.01 157.204 354.884 157.119 354.632 157.119C354.375 157.119 354.249 157.204 354.078 157.501L346.943 170.2ZM366.268 177.208H342.995L339.682 183.069H330.041L346.178 155.124C347.452 152.914 349.279 151.217 352.931 151.217H356.541C360.195 151.217 362.019 152.914 363.293 155.124L379.43 183.069H369.581L366.268 177.208ZM382.401 180.775L381.596 180.519L383.761 173.599C389.96 175.594 396.586 176.4 402.573 176.4C412.385 176.4 414.807 175.252 414.807 174.023C414.807 173.514 414.465 173.131 413.7 172.875C412.723 172.537 410.004 171.984 401.978 170.669C393.102 169.224 389.113 168.5 386.182 167.14C383.252 165.785 381.465 163.616 381.465 160.433C381.465 158.011 382.658 156.058 384.567 154.527C387.965 151.894 393.781 150.836 400.11 150.836C408.266 150.836 415.104 151.515 422.703 153.384L423.383 153.595L421.559 160.348C413.065 158.52 408.352 158.011 401.897 157.926C397.351 157.885 394.209 158.223 392.552 158.732C391.616 159.033 391.233 159.456 391.233 159.965C391.233 160.433 391.531 160.856 392.467 161.153C393.484 161.495 395.141 161.878 403.847 163.278C413.277 164.808 416.378 165.443 418.967 166.465C422.491 167.82 424.616 170.327 424.616 173.469C424.616 177.421 421.559 180.352 416.248 181.964C412.98 182.94 408.604 183.494 403.68 183.494C395.95 183.494 387.709 182.472 382.401 180.775Z",
    fill: "#323232"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_730_18201",
    x1: 120.486,
    y1: 196.351,
    x2: 70.5841,
    y2: 123.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE0000",
    stopOpacity: 0.9961
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_730_18201",
    x1: 106.592,
    y1: 163.305,
    x2: 107.264,
    y2: 155.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#A2A5A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2A5A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_730_18201",
    x1: 96.716,
    y1: 183.58,
    x2: 129.06,
    y2: 183.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A2A5A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2A5A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_730_18201",
    x1: 56.3206,
    y1: 150.037,
    x2: 92.4751,
    y2: 150.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2A5A3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.254af2f6a24ba79d95fd2c3d5c135199.svg";
export { ForwardRef as ReactComponent };